import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PurchaseOrderListLayer from "../components/PurchaseOrderListLayer";


export const PurchaseOrderListPage = () => {
  return (
    <MasterLayout>
        <PurchaseOrderListLayer />
    </MasterLayout>
  );
};
